import TrackingService from "./tracking_service";
import BrandTile from "./brandTile";
import {TrackingFeatureLabels} from "../types";

const PROMO_MO_BRAND_SHOPPROMO_CSS_BASECLASS = "promo_brandshoppromo_mo"
const PROMO_BRAND_SHOPPROMO_CSS_BASECLASS = "promo_brandshoppromo"

export default class PromoBrandShopPromo {
    private readonly baseCssClass: string;
    private readonly promoType: string;
    private readonly featureOrder: number;
    private readonly masFeatureTrackingLabels: TrackingFeatureLabels;
    private readonly featureIndex: number;
    private readonly brandTiles: BrandTile[];
    private readonly filledSlots: number;
    private readonly trackingService: TrackingService;

    constructor(container: HTMLElement) {
        // We only need this during the transition phase to the new MO design, because we need to support two layouts
        if (container.className.includes(PROMO_MO_BRAND_SHOPPROMO_CSS_BASECLASS)) {
            this.baseCssClass = PROMO_MO_BRAND_SHOPPROMO_CSS_BASECLASS
        } else {
            this.baseCssClass = PROMO_BRAND_SHOPPROMO_CSS_BASECLASS
        }

        this.promoType = this._getPromoType(container);
        this.featureOrder = this._getFeatureOrder(container);
        this.masFeatureTrackingLabels = this._getMasFeatureTrackingLabels(container);
        this.featureIndex = this._getFeatureIndex(container);
        const brandTileDoms = container.querySelectorAll(`.${this.baseCssClass}--tile`);
        this.brandTiles = Array.from(brandTileDoms).map((brandTileDom: Element, index: number) => new BrandTile(brandTileDom, index + 1))
        this.filledSlots = this.brandTiles.length;
        this.trackingService = new TrackingService();
        this.trackView();

        [].map.call(brandTileDoms, (brandTileDom: HTMLElement, index: number) => {
            brandTileDom.addEventListener("click", this.trackClick(this.brandTiles[index]), false);
        })
    }

    trackClick(brandTile: BrandTile): () => void {
        const self = this;
        return function () {
            self.trackingService.sendClickTrackingEvent(self.featureOrder, self.featureIndex, brandTile, self.filledSlots, self.promoType, self.masFeatureTrackingLabels);
        }
    }

    trackView(): void {
        this.trackingService.sendViewTracking(this.featureOrder, this.featureIndex, this.promoType, this.brandTiles, this.masFeatureTrackingLabels);
    }

    _getPromoType(container: HTMLElement): string {
        return container.getAttribute("data-promo-type")!;
    }

    _getFeatureOrder(container: HTMLElement): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    _getMasFeatureTrackingLabels(container: HTMLElement): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute("data-feature-tracking-labels");
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    _getFeatureIndex(container: HTMLElement): number {
        return parseInt(container.getAttribute('data-feature-index')!, 0);
    }

}
